import { useCallback } from "react";
import { toast } from "react-toastify";

export function useCollectionActions({ collection, updateCollection }) {
  const addSwingToCollection = useCallback(
    async (videoId) => {
      if (!collection?.videoIds) return;

      // Don't add if already in collection
      if (collection.videoIds.includes(videoId)) return;

      const updatedVideoIds = [...collection.videoIds, videoId];

      try {
        await updateCollection({
          collectionId: collection.id,
          collectionName: collection.collectionName,
          videoIds: updatedVideoIds,
        });
        toast.success("Swing added to collection");
      } catch (error) {
        console.error("Failed to add swing to collection:", error);
        throw error;
      }
    },
    [collection, updateCollection]
  );

  const removeSwingFromCollection = useCallback(
    async (videoId) => {
      if (!collection?.videoIds) return;

      const updatedVideoIds = collection.videoIds.filter(
        (id) => id !== videoId
      );

      try {
        await updateCollection({
          collectionId: collection.id,
          collectionName: collection.collectionName,
          videoIds: updatedVideoIds,
        });
        toast.success("Swing removed from collection");
      } catch (error) {
        console.error("Failed to remove swing from collection:", error);
        throw error;
      }
    },
    [collection, updateCollection]
  );

  const isSwingInCollection = useCallback(
    (videoId) => {
      return collection?.videoIds?.includes(videoId) ?? false;
    },
    [collection?.videoIds]
  );

  return {
    addSwingToCollection,
    isSwingInCollection,
    removeSwingFromCollection,
  };
}
